/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function useRemotePromise<T = undefined>(o?: { noDisopse: boolean }) {
  let isResolved: undefined | { res: T } = undefined
  let resoveCb: ((i: T) => void)[] = []
  if (!o?.noDisopse) onScopeDispose(() => (resoveCb = []))

  return {
    isResolved: () => !!isResolved,
    wait: () => {
      return new Promise<T>((resolve) => {
        if (isResolved) resolve(isResolved.res)
        else resoveCb.push((i) => resolve(i))
      })
    },
    resolve: (res: T) => {
      if (isResolved) return
      isResolved = { res }
      resoveCb.forEach((i) => i(res))
      resoveCb = []
    },
  }
}
